import type { NavItem } from '../types/navItem'
import type { NavItemSeparator } from '../types/navItemSeparator'
import { createSeparatorItem } from './createSeparatorItem'

/**
 * Joins NavItem groups into a flat list with separators between non-empty groups.
 *
 * @example
 * joinNavItemGroups([
 *   [primaryAction],
 *   [sendAction, downloadAction],
 *   isDeletable ? [deleteAction] : [],
 * ])
 */

export const joinNavItemGroups = <T>(groups: NavItem<T>[][]): NavItem<T | NavItemSeparator>[] =>
  groups
    .filter((group) => group.length > 0)
    .flatMap((group, groupIndex) => (groupIndex === 0 ? group : [createSeparatorItem(groupIndex), ...group]))
